import RolEdit from './RolesEdit'

export default {
  edit: RolEdit,
}
